import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiftBuyPageComponent } from './gift-buy-page.component';
import { SectionHeaderGapModule } from 'src/app/shared/section-header-gap/section-header-gap.module';
import { SectionGiftUseCasesModule } from '../../shared/section-gift-use-cases/section-gift-use-cases.module';

import { SectionStepsModule } from 'src/app/shared/section-steps/section-steps.module';
import { SectionFaqModule } from 'src/app/shared/section-faq/section-faq.module';
import { SectionGiftBooksModule } from 'src/app/shared/section-gift-books/section-gift-books.module';
import { SectionGiftHeaderComponent } from './components/section-gift-header/section-gift-header.component';
import { SectionGiftCartModule } from '../../shared/section-gift-cart/section-gift-cart.module';
import { SectionGiftFaqModule } from '../../shared/section-gift-faq/section-gift-faq.module';
import { SectionGiftCheckoutModule } from 'src/app/shared/section-gift-checkout/section-gift-checkout.module';
import { ImageTitleModule } from 'src/app/shared/image-title/image-title.module';

@NgModule({
  declarations: [GiftBuyPageComponent, SectionGiftHeaderComponent],
  imports: [
    CommonModule,
    ImageTitleModule,
    SectionHeaderGapModule,
    SectionGiftUseCasesModule,
    SectionStepsModule,
    SectionFaqModule,
    SectionGiftBooksModule,
    SectionGiftCartModule,
    SectionGiftFaqModule,
    SectionGiftCheckoutModule,
  ],
})
export class GiftBuyPageModule {}
